import { PauseState } from '../pause/PauseManager';
import PersistenceEventType from '../persistence/PersistenceEventType';
import AbstractScheduledTaskState from './AbstractScheduledTaskState';
import ScheduledTaskStateType from './ScheduledTaskStateType';

class PausedState extends AbstractScheduledTaskState {
  handleEvent() {
    if (
      !this.isReviewScreen() &&
      this.testController.pauseManager?.currentPauseState !== PauseState.PAUSE &&
      this.testController.persistenceManager?.currentEventType === PersistenceEventType.COMPLETE
    ) {
      this.scheduledTaskManager.updateState(ScheduledTaskStateType.RUNNING);
    } else {
      this.scheduledTaskManager.clearScheduler();
    }
  }
}

export default PausedState;
